import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';

// #region interfaces

interface FeedbackSummaryProps {
  statusTime: string;
}

// #endregion

const FeedbackSummary: React.FC<FeedbackSummaryProps> = (props) => {

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      flexGrow: 1,
      padding: theme.spacing(0, 2, 0, 2),
    }
  };

  // #endregion

  return (
    <Box sx={styles.root}>
      {props.statusTime &&
        <Grid container>
          <Typography variant="body1">{`As of: ${props.statusTime}`}</Typography>
        </Grid >
      }
    </Box >
  );

}

export default FeedbackSummary;